export default "__VITE_ASSET__CqmNm248__"